import { styled, css } from 'styled-components';

import { mq, flexCol } from '@/shared/ui/styled';

export const TabsWrapper = styled.div`
    ${flexCol}

    ${mq.gt.md} {
        flex-direction: column-reverse;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    padding: 42px 32px;
    background-color: ${({ theme }) => theme.color.secondary};
    border-radius: 8px;
    box-sizing: border-box;
    ${mq.lt.xl} {
        padding: 32px 16px;
    }
    ${mq.lt.md} {
        padding: 16px;
    }
`;

const cssProductContainerLangPage = css`
    .right-column {
        .column__action {
            ${mq.lt.md} {
                display: none;
            }
        }
    }
`;
const cssProductContainerDefaultPage = css`
    .right-column {
        ${mq.lt.md} {
            display: flex;
            flex-direction: column-reverse;
        }

        .column__action {
            margin-top: 30px;
            ${mq.lt.md} {
                margin-top: 0;
            }
        }
    }
`;

export const ProductContainer = styled.div<{ $isLang: boolean }>`
    display: flex;
    gap: 32px;

    ${mq.lt.lg} {
        flex-direction: column;
    }

    .right-column {
        flex: 1;

        .column__calculation {
            display: flex;
            align-items: flex-start;
            gap: 64px;
            ${mq.lt.xl} {
                gap: 32px;
            }

            ${mq.lt.sm} {
                flex-direction: column;
                gap: 10px;
            }

            .column__block-calc {
                width: 100%;
                max-width: 300px;
                ${mq.lt.lg} {
                    flex: 1;
                    max-width: unset;

                    .block-calc__component {
                        flex: 1;
                        max-width: 100%;
                    }
                }
                ${mq.lt.sm} {
                    margin-top: 24px;
                    max-width: 100%;
                    width: 100%;
                }
            }

            .column__block-info-calc {
                max-width: 220px;
                width: 100%;
                ${mq.lt.lg} {
                    flex: 1;
                    max-width: 100%;
                }

                ${mq.lt.sm} {
                    max-width: 100%;
                    margin-top: 24px;
                }

                .block-info-calc__buyout {
                    margin-top: 20px;
                }
            }
        }

        .column__action {
            margin-top: 30px;
        }
    }

    ${({ $isLang }) => ($isLang ? cssProductContainerLangPage : cssProductContainerDefaultPage)}
`;

export const ReservationWrapper = styled.form`
    display: flex;
    margin: 0 auto;
    gap: 32px;
    flex-direction: column;
    max-width: 364px;

    .inputs {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .icon-box {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .inputBox {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .after-input-text {
        font-size: 12px;
        font-weight: 400;
        color: #818c99;
    }

    .error {
        color: #fd397a;
    }

    .agreement {
        font-size: 14px;
        font-weight: 400;

        .link-span {
            color: #00d9de;
        }
    }

    .textButton {
        border: none;
        background: none;
        font-size: 14px;
        font-weight: 600;
        color: #1f2547;
        cursor: pointer;

        &:hover {
            color: gray;
        }
    }
`;

export const ReservationNotificationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
        white-space: nowrap;
        font-weight: 600;
        ${mq.lt.md} {
            white-space: normal;
        }
    }
`;
